module.exports = __webpack_public_path__ + "img/LOGO.ca198e3d.png";